import React from 'react';
import { Helmet } from 'react-helmet';

interface HtmlMetaProps {
  htmlMeta: {
    canonicalUrl?: string;
    description?: string;
    keywords?: string;
    next?: string;
    ogImage?: string;
    prev?: string;
    robots?: string;
    title?: string;
    imageUrl?: string;
  };
  baseUrl: string;
}

const HtmlMeta = ({
  htmlMeta: {
    canonicalUrl,
    description,
    keywords,
    next,
    ogImage,
    prev,
    robots,
    title,
    imageUrl,
  },

  baseUrl,
}: HtmlMetaProps) => (
  <Helmet>
    <title>{title}</title>

    <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
    <link rel="manifest" href="/manifest.json" />
    <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#00ffd0" />

    <meta name="og:locale" content="de_AT" />

    {ogImage && <meta name="og:image" content={ogImage} />}

    <meta name="og:title" content={title} />

    <meta name="og:type" content="website" />
    {canonicalUrl && (
      <meta name="og:url" content={`${baseUrl}${canonicalUrl}`} />
    )}

    {imageUrl && <meta name="og:image" content={imageUrl} />}

    <meta name="og:site_name" content="immobilienscout24.at" />

    <meta name="og:description" content={description} />

    <meta name="description" content={description} />

    <meta name="keywords" content={keywords} />

    {prev && <link rel="prev" href={`${baseUrl}${prev}`} />}
    {canonicalUrl && (
      <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />
    )}

    {next && <link rel="next" href={`${baseUrl}${next}`} />}

    <meta name="robots" content={robots} />
  </Helmet>
);

export default HtmlMeta;
